import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { Auth } from './auth';

// authInterceptor 给请求注入 Authorization: Bearer，并在 401 时用 refresh_token 静默续期重试一次。
// 登录/刷新等公开端点本身不参与续期，避免无限循环。
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const router = inject(Router);
  const token = auth.currentToken();
  const authed = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  const isAuthFlow =
    req.url.includes('/auth/login') ||
    req.url.includes('/token/refresh') ||
    req.url.includes('/auth/oauth') ||
    req.url.includes('/auth/passkey/login') ||
    req.url.includes('/auth/mfa/login');

  return next(authed).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 401 || !token || isAuthFlow) {
        return throwError(() => err);
      }
      return from(auth.refresh()).pipe(
        switchMap((ok) => {
          // 续期失败（refresh 也过期/吊销）：清会话并跳登录页，避免停在报错页面。
          if (!ok) {
            auth.logout();
            router.navigate(['/login']);
            return throwError(() => err);
          }
          const fresh = auth.currentToken();
          return next(req.clone({ setHeaders: { Authorization: `Bearer ${fresh}` } }));
        }),
      );
    }),
  );
};
